import { twMerge } from 'tailwind-merge';
import React, { ReactNode } from 'react';
import Icon from './Icon';

interface Props {
    description?: ReactNode;
    className?: string;
    children: ReactNode;
}

const LockedLink = ({ description, className, children }: Props) => (
    <div
        className={twMerge(
            'flex w-full cursor-not-allowed items-center justify-between rounded-sm p-2 text-gray-400 hover:bg-gray-100',
            className,
        )}
    >
        <div className="flex items-center gap-x-3">{children}</div>
        <div className="flex items-center gap-x-1">
            <div>
                <div className="text-sm">{description}</div>
            </div>
            <Icon iconKey="lock" className="text-gray-400 rtl:scale-x-[-1]" />
        </div>
    </div>
);

export default LockedLink;
